import React from 'react';
import CreateClock from 'react-live-clock';
import Box from "@mui/material/Box";

export default function Clock () {
    return (
        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <CreateClock
                format={'DD/MM/YY HH:mm [GMT+3]'}
                ticking={true}
                timezone={'Europe/Chisinau'} // или другая нужная таймзона
            />
        </Box>
    );
}
